"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MetaInformation =
/** @class */
function () {
  function MetaInformation(initialData, storage, storageKey, validate) {
    this.callbacks = [];
    this.data = initialData;
    this.storage = storage;
    this.storageKey = storageKey;
    this.validate = validate;
  }

  MetaInformation.prototype.setItem = function (key, value) {
    this.data[key] = value;
    this.storage.setItem(this.storageKey, JSON.stringify(this.data));
    this.callAll(this.data);
  };

  MetaInformation.prototype.clearStorage = function () {
    this.storage.removeItem(this.storageKey);
  };

  MetaInformation.prototype.initialize = function () {
    var store = this.storage.getItem(this.storageKey);
    if (!store) return null;

    try {
      return this.replaceData(JSON.parse(store));
    } catch (e) {
      return null;
    }
  };

  MetaInformation.prototype.replaceData = function (data) {
    var validatedValue = this.validate ? this.validate(data) : data;
    this.storage.setItem(this.storageKey, JSON.stringify(validatedValue));
    this.data = validatedValue;
    this.callAll(validatedValue);
    return validatedValue;
  };

  MetaInformation.prototype.subscribeDataChange = function (cb) {
    var _this = this;

    var uniqueId = Math.random();
    this.callbacks.push({
      uniqueId: uniqueId,
      cb: cb
    });
    return function () {
      _this.callbacks = _this.callbacks.filter(function (e) {
        return e.cb === cb && e.uniqueId === uniqueId;
      });
    };
  };

  MetaInformation.prototype.callAll = function (data) {
    var callbacks = this.callbacks;

    for (var i = 0; i < callbacks.length; i++) {
      callbacks[i].cb(data);
    }
  };

  return MetaInformation;
}();

exports.MetaInformation = MetaInformation;

exports.listenToLocalStorageChange = function (storage, metaInformationName, metaInformation) {
  if (!metaInformationName) return;
  if (storage !== localStorage) return;
  var info = storage.getItem(metaInformationName);

  var onStorageChange = function onStorageChange() {
    var newInfo = storage.getItem(metaInformationName);
    if (newInfo === info) return;
    info = newInfo;
    metaInformation.initialize();
  };

  window.addEventListener("storage", onStorageChange);
  return function () {
    window.removeEventListener("storage", onStorageChange);
  };
};